import React, { useEffect, useState } from "react";
import isEmpty from "../../lib/isEmpty";
import { socialNetwork } from "../../validation/companyprofile";
import { getProfile, socialMedia } from "../../services/auth";
import { toastError, toastSuccess } from "../../config/ToastModal";

const initialValues = {
  facebookUrl: "",
  twitterUrl: "",
  linkedinUrl: "",
  instagramUrl: "",
};

const SocialNetworkBox = ({ socialData }) => {
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState(initialValues);

  const { facebookUrl, twitterUrl, linkedinUrl, instagramUrl } = formValues;

  const handleBlur = ({ target: { name } }) => {
    setTouched({ ...touched, [name]: true });
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        facebookUrl,
        twitterUrl,
        linkedinUrl,
        instagramUrl,
        //  googleplusUrl,
      };

      if (facebookUrl || twitterUrl || linkedinUrl || instagramUrl) {
        const checkUrl =
          /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;

        if (
          checkUrl.test(
            facebookUrl || twitterUrl || linkedinUrl || instagramUrl
          )
        ) {
          const { status, message, errors } = await socialMedia(data);
          // Call your socialMedia function here if needed
          if (status == true) {
            toastSuccess(message);
          } else if (status == false && message) {
            toastError(message);
          } else if (errors) {
            setErrors(errors);
          }
        } else {
          toastError("Please enter a valid URL..!");
        }
      } else {
        toastError("Please enter at least one field..!");
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    setFormValues({
      facebookUrl: socialData?.facebookUrl,
      instagramUrl: socialData?.instagramUrl,
      linkedinUrl: socialData?.linkedinUrl,
      twitterUrl: socialData?.twitterUrl,
    });
  }, [socialData]);

  useEffect(() => {
    const checkValidation = socialNetwork(formValues);
    if (!checkValidation.status) {
      setErrors(checkValidation?.errors);
    } else {
      setErrors({});
    }
  }, [formValues]);

  return (
    <form className="default-form" onSubmit={handleSubmit}>
      <div className="row">
        {/* <!-- Input --> */}
        <div className="form-group col-lg-6 col-md-12">
          <label>
            Facebook <span style={{ color: "grey" }}>(Optional)</span>
          </label>
          <input
            type="text"
            name="facebookUrl"
            placeholder="eg https://www.facebook.com"
            value={facebookUrl}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched?.facebookUrl && (
            <span className="text-danger">{errors.facebookUrl}</span>
          )}
        </div>

        {/* <!-- Input --> */}
        <div className="form-group col-lg-6 col-md-12">
          <label>
            Twitters <span style={{ color: "grey" }}>(Optional)</span>
          </label>
          <input
            placeholder="eg https://www.Twitter.com"
            type="text"
            name="twitterUrl"
            value={twitterUrl}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched?.twitterUrl && (
            <span className="text-danger">{errors.twitterUrl}</span>
          )}
        </div>

        {/* <!-- Input --> */}
        <div className="form-group col-lg-6 col-md-12">
          <label>
            Linkedin <span style={{ color: "grey" }}>(Optional)</span>
          </label>
          <input
            type="text"
            name="linkedinUrl"
            placeholder="eg https://www.linkedin.com"
            value={linkedinUrl}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched?.linkedinUrl && (
            <span className="text-danger">{errors.linkedinUrl}</span>
          )}
        </div>

        {/* <!-- Input --> */}
        <div className="form-group col-lg-6 col-md-12">
          <label>
            Instagram <span style={{ color: "grey" }}>(Optional)</span>
          </label>
          <input
            type="text"
            name="instagramUrl"
            placeholder="eg https://www.instagram.com"
            value={instagramUrl}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched?.instagramUrl && (
            <span className="text-danger">{errors.instagramUrl}</span>
          )}
        </div>

        {/* <!-- Submit Button --> */}
        <div className="form-group col-lg-6 col-md-12 d-flex align-items-center justify-content-center w-100">
          <button
            type="submit"
            className="theme-btn btn-style-one"
            style={!isEmpty(errors) ? { cursor: "not-allowed" } : {}}
            disabled={!isEmpty(errors)}
          >
            Save
          </button>
        </div>
      </div>
    </form>
  );
};

export default SocialNetworkBox;
